import { JOB_STATUS_LABEL, type JobStatus } from '@/lib/api/types';
import { cn } from '@/lib/cn';

const TONE: Record<JobStatus, string> = {
  running: 'bg-tint-blue text-accent',
  pending: 'bg-sunken text-secondary',
  paused: 'bg-tint-purple text-purple',
  cancelling: 'bg-tint-purple text-purple',
  cancelled: 'bg-sunken text-secondary',
  done: 'bg-tint-blue text-success',
  failed: 'bg-tint-pink text-danger',
};

export function StatusBadge({ status }: { status: JobStatus }) {
  return (
    <span className={cn('rounded-full px-2.5 py-0.5 text-xs font-semibold', TONE[status])}>
      {JOB_STATUS_LABEL[status]}
    </span>
  );
}
